import { getCustomPdf, downloadPdf, openPrintPage } from 'b2b-common/services/api/document'
import { getHotelInfo } from 'b2b-common/services/api/hotel'

import { $gettext } from '@/config/gettext'

export default {
  data () {
    return {
      modal: false,
      priceDetailsModal: false,
      infoResults: [],
      selectedResults: [],
      searchIsRunning: false,
      selectedPriceFilters: null,
      currentPage: 1,
      resultsPerPage: 30,
      priceFilters: [
        { text: $gettext('all results'), value: null },
        { text: $gettext('price: < 100'), value: { min: Number.MIN_SAFE_INTEGER, max: 100 } },
        { text: $gettext('price: 100 - 500'), value: { min: 100, max: 500 } },
        { text: $gettext('price: 500 - 1000'), value: { min: 100, max: 500 } },
        { text: $gettext('price: > 1000'), value: { min: 1000, max: Number.MAX_SAFE_INTEGER } }
      ]
    }
  },
  computed: {
    paginatedResults () {
      return this.model.results.slice((this.currentPage - 1) * this.resultsPerPage, this.currentPage * this.resultsPerPage)
    },
    filteredResults () {
      if (!this.selectedPriceFilters) return this.model.results
      return this.model.results.filter(el =>
        (el.gross > this.selectedPriceFilters.min) && (el.gross <= this.selectedPriceFilters.max)
      )
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
      // document.getElementById('resultsHr').scrollIntoView()
    },
    async attachHotelInfo (results) {
      const hotels = []
      // get list of hotels without hotelInfo
      results.forEach(result => {
        if (!result.isInhouse && !result.isEtripHotels) {
          result.hotelInfo = {
            name: result.name,
            description: result.description,
            stars: result.stars,
            extraStars: result.extraStars,
            descriptions: [],
            images: result.images,
            files: []
          }
        }
        if (!result.hotelInfo) {
          hotels.push({
            id: result.id,
            isInhouse: result.isInhouse
          })
        }
      })

      // obtain hotelInfo for all hotels
      const info = hotels.length ? await getHotelInfo({ hotels }) : []

      if (!Array.isArray(info)) return 0

      info.forEach(hotel => {
        const list = results.filter(
          result => {
            const type = result.isInhouse ? 'INH' : 'ETR'
            return (result.id === hotel.id || result.id === (type + hotel.id)) && hotel.type === type
          })
        list.forEach(result => { result.hotelInfo = hotel })
      })

      return info.length
    },
    async onInfo (results) {
      this.infoResults = results
      this.modal = true
    },
    async onInfoSelected () {
      await this.attachHotelInfo(this.selectedResults)
      this.infoResults = this.selectedResults
      this.modal = true
    },
    onHideSelected () {
      this.selectedResults = []
    },
    isSelected (result) {
      return this.selectedResults.indexOf(result) >= 0
    },
    onToggle (result) {
      const index = this.selectedResults.indexOf(result)
      if (index >= 0) this.selectedResults.splice(index, 1)
      else this.selectedResults.push(result)
    },
    onModalClose () {
      this.modal = false
    },
    priceDetails () {
      this.priceDetailsModal = true
    },
    closePriceDetailsModal () {
      this.priceDetailsModal = false
    },
    onPrint () {
      const html = document.getElementById('printArea').innerHTML
      openPrintPage({ html })
    },
    onDownload () {
      const html = document.getElementById('printArea').innerHTML
      getCustomPdf({ html })
        .then(pdfData => {
          downloadPdf({ pdfData, fileName: this.$pgettext('file name do not use special characters, please use ASCII only', 'offer') + '.pdf', dataType: 'raw' })
        })
    },
    onSort (sortMethod) {
      this.model.sort({ sortMethod })
    },
    onPaginate (noResults) {
      this.resultsPerPage = noResults
    },
    onSearch (params) {
      this.searchIsRunning = true
      this.infoResults = []
      this.model.search(params)
        .finally(() => { this.searchIsRunning = false })
    }
  }
}
